/* nav-hover-fix v2: keep mega panel open while cursor travels into it,
   AND re-measure the navigation bar after hidden/prerendered page loads
   (Chrome prerender makes overflow-list measure 0 -> nav collapses to fallback). */
(function () {
  function remeasure() { window.dispatchEvent(new Event("resize")); }
  if (document.visibilityState === "hidden") {
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible") { remeasure(); setTimeout(remeasure, 250); }
    });
  }
  window.addEventListener("pageshow", function () { setTimeout(remeasure, 100); });
  window.addEventListener("load", function () { setTimeout(remeasure, 300); setTimeout(remeasure, 1200); });

  function wire() {
    document.querySelectorAll("header .menu-list__submenu").forEach(function (sub) {
      if (sub.dataset.hoverFix) return;
      sub.dataset.hoverFix = "1";
      var li = sub.closest("li");
      if (!li) return;
      sub.addEventListener("pointerenter", function () {
        li.dispatchEvent(new PointerEvent("pointerenter", { bubbles: false }));
      });
      sub.addEventListener("pointerleave", function () {
        li.dispatchEvent(new PointerEvent("pointerleave", { bubbles: false }));
      });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", wire);
  else wire();
  new MutationObserver(wire).observe(document.documentElement, { subtree: true, childList: true });
})();
